import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { AuthService } from '../../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class hasRoleGuard implements CanActivate {


  constructor(
    protected readonly router: Router,
    protected readonly auth: AuthService
) {

  }

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    const allowedPermissions: RoutePermissionRestriction[] = (route.data['permissions'] as RoutePermissionRestriction[]) ?? [];
    
    if (allowedPermissions.some(restriction => this.auth.hasAnyPermission(restriction.permissions))) {
      return true; 
    }

    // Redirect to 401 page if unauthorized
    return this.router.createUrlTree(['/401']);
  }

}

export interface RoutePermissionRestriction {
  permissions: string[]
}
